import {
  AllPaymentRequestsInsightsDocument,
  DeleteBankingPaymentRequestDocument,
  PaymentRequestsDataCollectionDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

export const useDeletePaymentRequest = () => {
  const [deletePaymentRequest, { loading }] = useMutation(DeleteBankingPaymentRequestDocument, {
    extractorFn: (data) => data.bankingMutations.deleteBankingPaymentRequest,
    refetchQueries: [PaymentRequestsDataCollectionDocument, AllPaymentRequestsInsightsDocument],
    awaitRefetchQueries: true,
  })

  const submitDelete = async ({ id }: { id: number }) => {
    const result = await deletePaymentRequest({
      variables: { id },
    })
    const handled = handleResult(result, () => {})
    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('banking.paymentRequests.deleted'),
      })
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('errors.generic_error'),
      })
    }
    return handled
  }

  return {
    submitDelete,
    loading,
  }
}
